import { render, staticRenderFns } from "./MedicationRoute.vue?vue&type=template&id=e2d190f6&"
import script from "./MedicationRoute.vue?vue&type=script&lang=js&"
export * from "./MedicationRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports